import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography ,IconButton} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';

export const FamilyHistoryDetailsForm = ({ onAdd, onClose, editData, isEditMode, setFamilyHistoryDialogueOpen }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        disease: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmit = (formValue) => {
    onAdd(formValue);
    setFamilyHistoryDialogueOpen(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
         <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" sx={{ marginBottom:2,borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{marginBottom:"2%"}}>
          Family History
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginLeft: '1%' }}>
        <Stack spacing={2}>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Disease</Typography>
            <TextField sx={{ flex: 1 }} name="disease" placeholder="Enter Disease" />
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Relation</Typography>
            <TextField sx={{ flex: 1 }} name="relation" placeholder="Enter Relation" />
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Description</Typography>
            <TextField sx={{ flex: 1 }} name="description" placeholder="Description" />
          </Stack>
        </Stack>
      </Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
